module.exports = __webpack_public_path__ + "static/media/powerforallclinic.27095d46.jpg";